// Funil de vendas (AC-207 / AC-208): quando o tempo grátis acaba, um pop-up com
// "Seu tempo grátis chegou ao fim!", memes tristes trocando a cada 3 s e "Ver planos".
// Fechar no X deixa ver as tarefas (só leitura) até a próxima abertura do app (ASM-102).
// Com "Comemoração" desligada, o pop-up aparece sem os memes (AC-230).
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCelebrationOn } from './Celebration';
import { Dialog } from './EditTaskDialog';
import { Icon } from './Icon';
import { memeUrl, SAD_MEMES } from './memes';
import { cls } from './NewTaskForm';

export const SAD_MEME_MS = 3000;

export function TrialEndedDialog({ onPlans, onClose }: { onPlans(): void; onClose(): void }) {
  const { t } = useTranslation();
  const memes = useCelebrationOn();
  const [shown, setShown] = useState(0);
  useEffect(() => {
    if (!memes) return;
    const id = setInterval(() => setShown((i) => (i + 1) % SAD_MEMES.length), SAD_MEME_MS);
    return () => clearInterval(id);
  }, [memes]);

  return (
    <Dialog labelId="trial-ended-title" onClose={onClose}>
      <div className="trial-ended" data-testid="trial-ended">
        <h2 id="trial-ended-title" className="dialog__title trial-ended__title">
          {t('funnel.title')}
        </h2>
        {/* todos carregados de uma vez; só o da vez aparece (troca suave, sem piscar) */}
        {memes && (
          <div className="trial-ended__memes">
            {SAD_MEMES.map((id, i) => (
              <img
                key={id}
                className={cls('meme trial-ended__meme', i === shown && 'is-on')}
                src={memeUrl(id)}
                alt={i === shown ? t('funnel.memeAlt') : ''}
                aria-hidden={i !== shown}
                data-meme={id}
                draggable={false}
              />
            ))}
          </div>
        )}
        <p className="dialog__body">{t('funnel.body')}</p>
        <button type="button" className="btn btn--cta" onClick={onPlans}>
          {t('funnel.seePlans')}
        </button>
        {/* depois do "Ver planos" no código, para o foco inicial cair nele; fica no canto pelo CSS */}
        <button type="button" className="icon-btn trial-ended__close" aria-label={t('common.close')} onClick={onClose}>
          <Icon name="x" size={14} />
        </button>
      </div>
    </Dialog>
  );
}
